import React from 'react';
import { childClassNameProp } from '@monorepo/type';

const Row = ({ children, className }: childClassNameProp) => (
  <tr className={className}>{children}</tr>
);

export default Row;
